export default __webpack_public_path__ + "static/unlock-4a190db60fad30bb97b7be277cc0acb9.png";